import React from 'react';
import { isEmpty } from 'lodash';
import { V3 } from '../../api_request';
import ComparisonShoppingPage from './comparison_shopping_page';
import ComparisonShoppingPagesCard from './csp_card';
import { cspsFindPath } from '../../shared/url_helpers';
import classNames from 'classnames';
import * as elog from '@reverbdotcom/commons/src/elog';

interface IProps {
  slug: string;
  id: number;
  floated: boolean;
}

interface IState {
  page: any;
}

export default class ComparisonShoppingPageCardManager extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      page: {},
    };
  }

  componentDidMount() {
    const { slug, id } = this.props;
    if (slug || id) {
      V3.get(cspsFindPath.expand({ slug, id }))
        .then((response) => {
          const page = new ComparisonShoppingPage(response);
          this.setState({ page });
        })
        .fail((err) => {
          elog.info('blog_csp_embed_missing_404', { slug, id, err });
        });
    }
  }

  render() {
    if (isEmpty(this.state.page)) { return null; }

    const classes = classNames(
      'csp-embed-card',
      { 'csp-embed-card--floated': this.props.floated },
    );

    return (
      <section className={classes}>
        <ComparisonShoppingPagesCard
          page={this.state.page}
        />
      </section>
    );
  }
}
